<template>
    <b-card no-body class="card-search-form">
        <div v-b-toggle="dataId" slot="header">
            {{caption}}
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize">
                    <i class="fa fa-chevron-down"></i>
                </b-link>
            </div>
        </div>
        <b-collapse :id="dataId">
            <b-card-body>
                <CForm
                        ref="form"
                        @onSubmit="onSubmit"
                        @onReset="onReset"
                        :options="{ submit: { text: 'Rechercher', variant: 'info'}, reset: { text: 'Réinitialiser', variant: 'light'} }"
                        :structure="structure">
                </CForm>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>
<script>
    import CForm from './CForm'
    export default {
        extends: CForm,
        name: 'CardSearchForm',
        components: {
            CForm
        },
        props: {
            caption: {
                type: String,
                default: ''
            },
            structure: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        mounted() {
            let id = Core.Text.generateHash()
            this.dataId = id
        },
        data: function () {
            return {
                dataId :''
            }
        },
        methods: {
            getFormFieldRefs() {
                return this.$refs.form.fieldRefs
            },
            onSubmit(form, fieldRefs, structure) {
                this.$emit('onSubmit', form, fieldRefs, structure)
            },
            onReset(form, fieldRefs, structure) {
                this.$emit('onReset', form, fieldRefs, structure)
            }
        }
    }
</script>

